<template>
  <v-list-item
    class="user-menu-item"
    :class="{ 'user-menu-item--danger': danger }"
    :to="to"
    :href="href"
    :target="target"
    @click="onClick"
  >
    <v-list-item-action v-if="icon" class="user-menu-item__action">
      <v-icon small>{{ iconName }}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title class="user-menu-item__title"><slot /></v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  props: {
    icon: { type: String, default: '' },
    danger: { type: Boolean, default: false },
    to: { type: Object, default: undefined },
    href: { type: String, default: undefined },
    target: { type: String, default: undefined },
  },
  computed: {
    iconName(): string {
      return this.icon ? `$vuetify.icons.${this.icon}` : ''
    },
  },
  methods: {
    onClick(event: MouseEvent) {
      this.$emit('click', event)
    },
  },
})
</script>

<style lang="scss" scoped>
.user-menu-item {
  min-height: calc(40px * 1.05) !important;
  border-radius: 8px;
  margin: 1px 0;
  align-items: center !important;
  color: #231f20 !important;

  &:hover {
    background: #f3f4f6 !important;
  }
}

.user-menu-item__action {
  margin: 0 12px 0 12px !important;
  min-width: 20px !important;
  align-self: center !important;

  .v-icon {
    color: #231f20 !important;
    font-size: calc(15em / 14) !important;
  }
}

:deep(.v-list-item__content) {
  align-self: center !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.user-menu-item__title {
  font-size: 1em;
  font-weight: 600;
  color: #231f20 !important;
  line-height: 1.3;
}

.user-menu-item--danger {
  .user-menu-item__title {
    color: #dc2626 !important;
  }

  .user-menu-item__action .v-icon {
    color: #dc2626 !important;
  }

  &:hover {
    background: #fef2f2 !important;
  }
}
</style>
